import React from 'react';
import { Button, Header, Modal, Message } from 'semantic-ui-react';
import { FieldDiff } from './types';
import {
  CancellationBanner,
  DiffLabel,
  DiffList,
  DiffNew,
  DiffOld
} from './styles';

type ConfirmPolicyChangesModalProps = {
  open: boolean;
  diffs: FieldDiff[];
  isLoading: boolean;
  isCancellation: boolean;
  cancellationReason?: string;
  refundValue?: string;
  onBack: () => void;
  onConfirm: () => void;
};

const ConfirmPolicyChangesModal = ({
  open,
  diffs,
  isLoading,
  isCancellation,
  cancellationReason,
  refundValue,
  onBack,
  onConfirm
}: ConfirmPolicyChangesModalProps) => {
  return (
    <Modal open={open} onClose={onBack} size="small" closeOnDimmerClick={!isLoading}>
      <Header icon="warning sign" content="Confirmar alterações da apólice" />
      <Modal.Content scrolling>
        {isCancellation && (
          <CancellationBanner>
            <strong>Atenção: cancelamento de apólice</strong>
            <div style={{ marginTop: 8 }}>
              Motivo: {cancellationReason || '—'}
            </div>
            {refundValue ? (
              <div style={{ marginTop: 4 }}>Reembolso: R$ {refundValue}</div>
            ) : null}
          </CancellationBanner>
        )}

        <Message info>
          Revise as alterações abaixo antes de confirmar. Somente os campos
          modificados são listados.
        </Message>

        {diffs.length === 0 ? (
          <Message warning>Nenhuma alteração detectada.</Message>
        ) : (
          <DiffList>
            {diffs.map((diff) => (
              <li key={diff.key}>
                <DiffLabel>{diff.label}</DiffLabel>
                <DiffOld>{diff.oldValue}</DiffOld>
                <span aria-hidden>→ </span>
                <DiffNew>{diff.newValue}</DiffNew>
              </li>
            ))}
          </DiffList>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={isLoading} onClick={onBack}>
          Voltar e revisar
        </Button>
        <Button
          color="green"
          loading={isLoading}
          disabled={isLoading || diffs.length === 0}
          onClick={onConfirm}
        >
          Confirmar alterações
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmPolicyChangesModal;
